// open popup and inject product data
window.openQuotePopup = function(title, image){

  const popup = document.getElementById('quotePopup');
  if(!popup) return;

  popup.style.display = 'flex';

  // product title
  const titleBox = document.getElementById('quoteProductTitle');
  if(titleBox){
    titleBox.innerText = title;
  }

  // product image
  const img = document.getElementById('quoteProductImage');
  if(img){
    img.src = image;
  }

  // textarea message
  const msg = document.getElementById('quoteMessage');
  if(msg){
    msg.value =
`Hello,
I would like to request a quote for ${title}.
Please share price, delivery time, and warranty details.`;
  }
};


// close popup
window.closeQuotePopup = function(){
  const popup = document.getElementById('quotePopup');
  if(popup){
    popup.style.display = 'none';
  }
};


// click outside close
window.overlayClose = function(event){
  const popup = document.getElementById('quotePopup');
  if(event.target === popup){
    popup.style.display = 'none';
  }
};



document.addEventListener("DOMContentLoaded", function(){

  const form = document.getElementById("quoteContactForm");
  if(!form) return;

  form.addEventListener("submit", function(e){
    e.preventDefault(); // STOP shopify redirect

    const formData = new FormData(form);

    fetch("/contact", {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "application/json"
      }
    })
    .then(response => {

      // hide form
      form.style.display = "none";

      // show success message
      const success = document.querySelector(".quote-success");
      if(success){
        success.style.display = "block";
      }

    })
    .catch(error => {
      alert("Something went wrong. Please try again.");
    });

  });

});

